
      var _g, _path, _filter, _linearGradient, _linearGradient2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgServiceCenter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 122,
  height: 132,
  viewBox: "0 0 82 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#service-center_78718b6c1bc292d5__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 33,
  r: 15,
  fill: "url(#service-center_78718b6c1bc292d5__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41 8c13.807 0 25 11.193 25 25 0 12.093-8.587 22.18-19.996 24.498L41 64l-5.005-6.502C24.586 55.18 16 45.093 16 33 16 19.193 27.193 8 41 8m0 6c-10.493 0-19 8.507-19 19s8.507 19 19 19 19-8.507 19-19-8.507-19-19-19",
  fill: "url(#service-center_78718b6c1bc292d5__c)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M48.287 27.652c-.053.125-.08.25-.15.33-.16.198-.33.394-.525.555-.559.465-1.136.903-1.704 1.36-.462.366-.923.733-1.323 1.18-.15.17-.293.358-.426.554-.151.224-.151.456-.044.707.248.59.55 1.154.86 1.708a87 87 0 0 1 2.46 4.695c.142.295.24.617.355.921.009.036.018.063.018.099.017.17-.062.268-.222.232a1.7 1.7 0 0 1-.515-.179 30 30 0 0 1-1.136-.706c-1.208-.796-2.406-1.592-3.605-2.388-.488-.322-.985-.617-1.527-.84-.408-.17-.834-.269-1.278-.224-.338.026-.657.143-.96.286-.54.268-1.038.617-1.517.984-.968.724-1.918 1.466-2.886 2.19-.204.162-.426.296-.648.439a1.6 1.6 0 0 1-.275.143c-.15.054-.248-.027-.23-.179.017-.125.053-.26.106-.375.257-.644.506-1.297.772-1.932.435-1.029.88-2.048 1.314-3.068.151-.366.284-.742.373-1.135.098-.456-.035-.823-.417-1.073a8 8 0 0 0-.675-.394c-.16-.09-.328-.179-.488-.268-.089-.054-.178-.108-.258-.17-.257-.197-.24-.438.054-.573.337-.152.683-.286 1.03-.41.532-.189 1.074-.359 1.615-.537.204-.072.39-.152.595-.233a2.54 2.54 0 0 0 1.199-1.002c.293-.447.541-.92.816-1.386.133-.214.267-.438.418-.635a.96.96 0 0 1 .355-.268c.248-.116.426-.063.595.161.106.143.195.295.284.447.168.286.328.573.506.85.16.25.39.411.674.465.187.035.382.062.569.044a61 61 0 0 0 1.793-.214c.932-.134 1.864-.286 2.796-.42.258-.036.524-.018.782-.01.106 0 .213.036.31.09.071.027.107.116.16.179",
  fill: "var(--theme-light, #f9f3fb)"
})), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
  id: "service-center_78718b6c1bc292d5__a",
  x: 0,
  y: 0,
  width: 122,
  height: 132,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.890196 0 0 0 0 0.823529 0 0 0 0 0.913725 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5477_2484"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5477_2484",
  result: "shape"
}))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "service-center_78718b6c1bc292d5__b",
  x1: 26,
  y1: 18,
  x2: 55.781,
  y2: 17.785,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary-grad, #bc32ce)"
}))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "service-center_78718b6c1bc292d5__c",
  x1: 16,
  y1: 8,
  x2: 65.636,
  y2: 7.679,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary-grad, #bc32ce)"
}))));

      const __svgRaw = "<svg width=\"122\" height=\"132\" viewBox=\"0 0 82 88\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g filter=\"url(#a)\"><circle cx=\"41\" cy=\"33\" r=\"15\" fill=\"url(#b)\"/><path d=\"M41 8c13.807 0 25 11.193 25 25 0 12.093-8.587 22.18-19.996 24.498L41 64l-5.005-6.502C24.586 55.18 16 45.093 16 33 16 19.193 27.193 8 41 8m0 6c-10.493 0-19 8.507-19 19s8.507 19 19 19 19-8.507 19-19-8.507-19-19-19\" fill=\"url(#c)\"/></g><path d=\"M48.287 27.652c-.053.125-.08.25-.15.33-.16.198-.33.394-.525.555-.559.465-1.136.903-1.704 1.36-.462.366-.923.733-1.323 1.18-.15.17-.293.358-.426.554-.151.224-.151.456-.044.707.248.59.55 1.154.86 1.708a87 87 0 0 1 2.46 4.695c.142.295.24.617.355.921.009.036.018.063.018.099.017.17-.062.268-.222.232a1.7 1.7 0 0 1-.515-.179 30 30 0 0 1-1.136-.706c-1.208-.796-2.406-1.592-3.605-2.388-.488-.322-.985-.617-1.527-.84-.408-.17-.834-.269-1.278-.224-.338.026-.657.143-.96.286-.54.268-1.038.617-1.517.984-.968.724-1.918 1.466-2.886 2.19-.204.162-.426.296-.648.439a1.6 1.6 0 0 1-.275.143c-.15.054-.248-.027-.23-.179.017-.125.053-.26.106-.375.257-.644.506-1.297.772-1.932.435-1.029.88-2.048 1.314-3.068.151-.366.284-.742.373-1.135.098-.456-.035-.823-.417-1.073a8 8 0 0 0-.675-.394c-.16-.09-.328-.179-.488-.268-.089-.054-.178-.108-.258-.17-.257-.197-.24-.438.054-.573.337-.152.683-.286 1.03-.41.532-.189 1.074-.359 1.615-.537.204-.072.39-.152.595-.233a2.54 2.54 0 0 0 1.199-1.002c.293-.447.541-.92.816-1.386.133-.214.267-.438.418-.635a.96.96 0 0 1 .355-.268c.248-.116.426-.063.595.161.106.143.195.295.284.447.168.286.328.573.506.85.16.25.39.411.674.465.187.035.382.062.569.044a61 61 0 0 0 1.793-.214c.932-.134 1.864-.286 2.796-.42.258-.036.524-.018.782-.01.106 0 .213.036.31.09.071.027.107.116.16.179\" fill=\"var(--theme-light, #f9f3fb)\"/><filter id=\"a\" x=\"0\" y=\"0\" width=\"122\" height=\"132\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/><feColorMatrix in=\"SourceAlpha\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/><feOffset dy=\"8\"/><feGaussianBlur stdDeviation=\"8\"/><feColorMatrix values=\"0 0 0 0 0.890196 0 0 0 0 0.823529 0 0 0 0 0.913725 0 0 0 1 0\"/><feBlend in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_5477_2484\"/><feBlend in=\"SourceGraphic\" in2=\"effect1_dropShadow_5477_2484\" result=\"shape\"/></filter><linearGradient id=\"b\" x1=\"26\" y1=\"18\" x2=\"55.781\" y2=\"17.785\" gradientUnits=\"userSpaceOnUse\"><stop offset=\".16\" stop-color=\"var(--theme-primary, #810ea9)\"/><stop offset=\"1\" stop-color=\"var(--theme-primary-grad, #bc32ce)\"/></linearGradient><linearGradient id=\"c\" x1=\"16\" y1=\"8\" x2=\"65.636\" y2=\"7.679\" gradientUnits=\"userSpaceOnUse\"><stop offset=\".16\" stop-color=\"var(--theme-primary, #810ea9)\"/><stop offset=\"1\" stop-color=\"var(--theme-primary-grad, #bc32ce)\"/></linearGradient></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/service-center.78718b6c1bc292d5bf555a0ce4a5449d.svg"),
        {
          React: SvgServiceCenter,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      